module.exports = __webpack_public_path__ + "static/media/thecrimemachine.dbdb630b.png";